import auth from "@/router/allRoutes/auth";
import liveView from "@/router/allRoutes/liveView";
import trackVideo from "@/router/allRoutes/trackVideo";
import driverScore from "@/router/allRoutes/driverScore";
import notification from "@/router/allRoutes/notification";
import license from "@/router/allRoutes/license";
import report from "@/router/allRoutes/report";
import maintenance from "@/router/allRoutes/maintenance";
import master from "@/router/allRoutes/master";
import setting from "@/router/allRoutes/setting";
import trackingTemp from "@/router/allRoutes/trackingTemp";
import others from "@/router/allRoutes/others";

import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [{
    path: '/',
    name: 'Dashboard',
    apollo: {},
    meta: {
        authRequired: true,
        hasAccess: true,
        beforeResolve(_, from, next) {
            if (localStorage.getItem('token') === null) {
                next({ name: 'Login' })
            } else {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.d1.read) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                }
            }
        }
    },
    component: () =>
        import( /* webpackChunkName: "dashboard" */ '@/router/views/dashboards/default')
},

...auth,
...liveView,
...trackVideo,
...driverScore,
...notification,
...license,
...report,
...maintenance,
...master,
...setting,
...trackingTemp,
...others,

]